import { render, staticRenderFns } from "./productTable.vue?vue&type=template&id=0f7fbdc9&scoped=true"
import script from "./productTable.vue?vue&type=script&lang=js"
export * from "./productTable.vue?vue&type=script&lang=js"
import style0 from "./productTable.vue?vue&type=style&index=0&id=0f7fbdc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7fbdc9",
  null
  
)

export default component.exports